import CircleWithX from './circle-with-x';

export * from './circle-with-x';
export default CircleWithX;
